import { combineReducers } from 'redux'

import {
  CLEAR_DEEPFAKE_FILTERS,
  CREATE_DEEPFAKE_KEY_PERSON_AD_GROUPS_ASYNC,
  CREATE_DEEPFAKE_PROFILE_ASYNC,
  CREATE_DEEPFAKE_PROFILES_BULK_ASYNC,
  DELETE_DEEPFAKE_KEY_PERSON_AD_GROUP_ASYNC,
  DELETE_DEEPFAKE_PROFILE_ASYNC,
  GET_DEEPFAKE_AD_GROUPS_ASYNC,
  GET_DEEPFAKE_AD_GROUPS_USER_COUNT_ASYNC,
  GET_DEEPFAKE_ALL_USERS_ASYNC,
  GET_DEEPFAKE_KEY_PERSON_AD_GROUPS_ASYNC,
  GET_DEEPFAKE_MAILBOX_LIST_ASYNC,
  GET_DEEPFAKE_PROFILES_ASYNC,
  SET_DEEPFAKE_FILTERS,
  SET_DEEPFAKE_MAILBOX_LIST_PAGE,
  SET_DEEPFAKE_MAILBOX_LIST_VALUE,
  SET_DEEPFAKE_PROFILES_ORDERING,
  SET_DEEPFAKE_PROFILES_PAGE,
  SET_DEEPFAKE_PROFILES_PAGE_SIZE,
  SET_EMPLOYEE_INFO,
  SET_EMPLOYEE_INFO_FIELD,
  UPDATE_DEEPFAKE_PROFILE_ASYNC,
} from './constants'
import meetingsReducer from './meetingsReducer'

const DEFAULT_PAGE_SIZE = 20

const initialState = {
  profilesData: {
    items: [],
    loader: false,
    error: null,
  },
  mailboxData: {
    data: [],
    page: 1,
    count: 0,
    loader: false,
    value: '',
  },
  allUsersData: {
    items: [],
    loader: false,
    error: null,
    page: 0,
    search: '',
    total: 0,
    perPage: 0,
    hasMore: false,
  },
  nonDeletedIdsData: {
    ids: [],
    loader: false,
    error: null,
  },
  adGroupsData: {
    items: [],
    loader: false,
    error: null,
    page: 0,
    search: '',
    total: 0,
    perPage: 0,
    hasMore: false,
  },
  adGroupsUserCountData: {
    results: null,
    lastFetchedGroupIds: [],
  },
  keyPersonAdGroupsData: {
    items: [],
    loader: false,
    error: null,
  },
  employeeInfo: {},
  keyMemberLoader: false,
  keyMemberError: null,
  bulkCreateResult: null,
  filters: {
    search: '',
    status: ['complete', 'partial'],
    page: 1,
    page_size: 50,
    ordering: '-updated_at',
  },
}

const deepfakeReducer =
  () =>
  (state = initialState, action = {}) => {
    if (!action?.type) {
      return state
    }

    switch (action.type) {
      // Get profiles
      case GET_DEEPFAKE_PROFILES_ASYNC.INITIATE:
        return {
          ...state,
          profilesData: {
            ...state.profilesData,
            loader: true,
            error: null,
          },
        }
      case GET_DEEPFAKE_PROFILES_ASYNC.SUCCESS:
        return {
          ...state,
          profilesData: {
            ...state.profilesData,
            items: action.payload?.items || [],
            count: action.payload?.total || 0,
            pages: action.payload?.pages || 1,
            page: action.payload?.page || 1,
            pageSize: action.payload?.size || DEFAULT_PAGE_SIZE,
            loader: false,
          },
        }
      case GET_DEEPFAKE_PROFILES_ASYNC.ERROR:
        return {
          ...state,
          profilesData: {
            ...state.profilesData,
            loader: false,
            error: action.error,
          },
        }

      // Get key person AD groups
      case GET_DEEPFAKE_KEY_PERSON_AD_GROUPS_ASYNC.INITIATE:
        return {
          ...state,
          keyPersonAdGroupsData: {
            ...state.keyPersonAdGroupsData,
            loader: true,
            error: null,
          },
        }
      case GET_DEEPFAKE_KEY_PERSON_AD_GROUPS_ASYNC.SUCCESS:
        return {
          ...state,
          keyPersonAdGroupsData: {
            items: action.payload?.items || [],
            loader: false,
            error: null,
          },
        }
      case GET_DEEPFAKE_KEY_PERSON_AD_GROUPS_ASYNC.ERROR:
        return {
          ...state,
          keyPersonAdGroupsData: {
            ...state.keyPersonAdGroupsData,
            loader: false,
            error: action.error,
          },
        }

      // Create profile
      case CREATE_DEEPFAKE_PROFILE_ASYNC.INITIATE:
      case CREATE_DEEPFAKE_PROFILES_BULK_ASYNC.INITIATE:
      case UPDATE_DEEPFAKE_PROFILE_ASYNC.INITIATE:
      case DELETE_DEEPFAKE_PROFILE_ASYNC.INITIATE:
      case CREATE_DEEPFAKE_KEY_PERSON_AD_GROUPS_ASYNC.INITIATE:
      case DELETE_DEEPFAKE_KEY_PERSON_AD_GROUP_ASYNC.INITIATE:
        return {
          ...state,
          keyMemberLoader: true,
          keyMemberError: null,
          bulkCreateResult: null,
        }
      case CREATE_DEEPFAKE_PROFILE_ASYNC.SUCCESS:
      case UPDATE_DEEPFAKE_PROFILE_ASYNC.SUCCESS:
      case DELETE_DEEPFAKE_PROFILE_ASYNC.SUCCESS:
      case CREATE_DEEPFAKE_KEY_PERSON_AD_GROUPS_ASYNC.SUCCESS:
        return {
          ...state,
          keyMemberLoader: false,
          keyPersonAdGroupsData: {
            items: action.payload?.items || [],
            loader: false,
            error: null,
          },
        }
      case CREATE_DEEPFAKE_PROFILES_BULK_ASYNC.SUCCESS:
        return {
          ...state,
          keyMemberLoader: false,
          keyMemberError: null,
          bulkCreateResult: action.payload || null,
        }
      case DELETE_DEEPFAKE_KEY_PERSON_AD_GROUP_ASYNC.SUCCESS: {
        // Remove the deleted group from the list using id field (key person ad group ID)
        const deletedGroupId = action.payload?.id
        return {
          ...state,
          keyMemberLoader: false,
          keyPersonAdGroupsData: {
            ...state.keyPersonAdGroupsData,
            items: state.keyPersonAdGroupsData.items.filter((item) => item.id !== deletedGroupId),
          },
        }
      }
      case CREATE_DEEPFAKE_PROFILE_ASYNC.ERROR:
      case CREATE_DEEPFAKE_PROFILES_BULK_ASYNC.ERROR:
      case UPDATE_DEEPFAKE_PROFILE_ASYNC.ERROR:
      case DELETE_DEEPFAKE_PROFILE_ASYNC.ERROR:
      case CREATE_DEEPFAKE_KEY_PERSON_AD_GROUPS_ASYNC.ERROR:
      case DELETE_DEEPFAKE_KEY_PERSON_AD_GROUP_ASYNC.ERROR:
        return {
          ...state,
          keyMemberLoader: false,
          keyMemberError: action.error,
        }

      // Mailbox list
      case GET_DEEPFAKE_MAILBOX_LIST_ASYNC.INITIATE:
        return {
          ...state,
          mailboxData: {
            ...state.mailboxData,
            loader: true,
          },
        }
      case GET_DEEPFAKE_MAILBOX_LIST_ASYNC.SUCCESS: {
        // If it's page 1, replace the data. Otherwise, append to existing data
        const newItems = action.payload?.data?.items || []
        const updatedData =
          action.payload?.data?.page === 1 ? newItems : [...state.mailboxData.data, ...newItems]

        return {
          ...state,
          mailboxData: {
            ...state.mailboxData,
            data: updatedData,
            count: action.payload?.data?.count || 0,
            loader: false,
          },
        }
      }
      case GET_DEEPFAKE_MAILBOX_LIST_ASYNC.ERROR:
        return {
          ...state,
          mailboxData: {
            ...state.mailboxData,
            loader: false,
          },
        }

      // Get all users
      case GET_DEEPFAKE_ALL_USERS_ASYNC.INITIATE: {
        const { page = 1, search = '' } = action.payload || {}
        const isFirstPage = page === 1

        return {
          ...state,
          allUsersData: {
            ...state.allUsersData,
            loader: true,
            error: null,
            search,
            page,
            hasMore: isFirstPage ? true : state.allUsersData.hasMore,
            items: isFirstPage ? [] : state.allUsersData.items,
          },
        }
      }
      case GET_DEEPFAKE_ALL_USERS_ASYNC.SUCCESS: {
        const {
          items = [],
          count = 0,
          perPage = items.length,
          page = 1,
          search = '',
        } = action.payload || {}
        const isFirstPage = page === 1
        const mergedItems = isFirstPage ? items : [...state.allUsersData.items, ...items]
        const hasMore = page * perPage < count

        return {
          ...state,
          allUsersData: {
            ...state.allUsersData,
            items: mergedItems,
            loader: false,
            error: null,
            page,
            search,
            total: count,
            perPage,
            hasMore,
          },
        }
      }
      case GET_DEEPFAKE_ALL_USERS_ASYNC.ERROR:
        return {
          ...state,
          allUsersData: {
            ...state.allUsersData,
            loader: false,
            error: action.error,
            hasMore: false, // Stop trying to load more on error
          },
        }

      // Get AD groups
      case GET_DEEPFAKE_AD_GROUPS_ASYNC.INITIATE: {
        const { page = 1, search = '' } = action.payload || {}
        const isFirstPage = page === 1

        return {
          ...state,
          adGroupsData: {
            ...state.adGroupsData,
            loader: true,
            error: null,
            search,
            page,
            hasMore: isFirstPage ? true : state.adGroupsData.hasMore,
            items: isFirstPage ? [] : state.adGroupsData.items,
          },
        }
      }
      case GET_DEEPFAKE_AD_GROUPS_ASYNC.SUCCESS: {
        const {
          items = [],
          total = 0,
          size: perPage = items.length,
          page = 1,
          search = '',
        } = action.payload || {}
        const isFirstPage = page === 1
        const mergedItems = isFirstPage ? items : [...state.adGroupsData.items, ...items]
        const hasMore = page * perPage < total

        return {
          ...state,
          adGroupsData: {
            ...state.adGroupsData,
            items: mergedItems,
            loader: false,
            error: null,
            page,
            search,
            total,
            perPage,
            hasMore,
          },
        }
      }
      case GET_DEEPFAKE_AD_GROUPS_ASYNC.ERROR:
        return {
          ...state,
          adGroupsData: {
            ...state.adGroupsData,
            loader: false,
            error: action.error,
          },
        }

      // Get AD groups user count
      case GET_DEEPFAKE_AD_GROUPS_USER_COUNT_ASYNC.SUCCESS: {
        // Epic now explicitly sets results and groupIds in payload
        const results = action.payload?.results || []
        const groupIds = action.payload?.groupIds || []

        // Normalize response format - handle both camelCase (from frontend) and snake_case (from API)
        const normalizedResults = results.map((result) => ({
          group_id: result.groupId ?? result.group_id,
          user_count: result.userCount ?? result.user_count,
          error: result.error || null,
        }))

        return {
          ...state,
          adGroupsUserCountData: {
            results: normalizedResults,
            lastFetchedGroupIds: groupIds,
          },
        }
      }

      // UI state
      case SET_DEEPFAKE_MAILBOX_LIST_PAGE:
        return {
          ...state,
          mailboxData: {
            ...state.mailboxData,
            page: action.payload?.page || 1,
          },
        }
      case SET_DEEPFAKE_MAILBOX_LIST_VALUE:
        return {
          ...state,
          mailboxData: {
            ...state.mailboxData,
            value: action.payload?.value || '',
          },
        }
      case SET_EMPLOYEE_INFO:
        return {
          ...state,
          employeeInfo: action.payload?.data || {},
        }
      case SET_EMPLOYEE_INFO_FIELD:
        return {
          ...state,
          employeeInfo: {
            ...state.employeeInfo,
            [action.payload?.field || '']: action.payload?.value,
          },
        }
      case SET_DEEPFAKE_FILTERS:
        return {
          ...state,
          filters: { ...state.filters, ...action.payload },
        }
      case CLEAR_DEEPFAKE_FILTERS:
        return {
          ...state,
          filters: { ...initialState.filters, status: [] },
        }
      case SET_DEEPFAKE_PROFILES_PAGE:
        return {
          ...state,
          filters: {
            ...state.filters,
            page: action.payload || 1,
          },
        }
      case SET_DEEPFAKE_PROFILES_PAGE_SIZE:
        return {
          ...state,
          filters: {
            ...state.filters,
            page_size: action.payload || 10,
          },
        }
      case SET_DEEPFAKE_PROFILES_ORDERING:
        return {
          ...state,
          filters: {
            ...state.filters,
            ordering: action.payload || '',
          },
        }

      default:
        return state
    }
  }

export default function () {
  // eslint-disable-next-line no-shadow
  const initialState = combineReducers({
    self: deepfakeReducer(),
    meetings: meetingsReducer,
  })

  return (state = initialState, action) =>
    // This reducer just passes through - combineReducers handles action dispatching
    state
}
